import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateConversionDraftsAPIResponse, TCreateGoldConversionReduxParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { MetalTypeEnum } from '~utils/enums';

export default function* watchCreateGoldConversionDrafts(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateGoldConversionDraftsAttempt', handleCreateGoldConversionDrafts, api);
}

function* handleCreateGoldConversionDrafts(api: GoldGateway, action: PayloadAction<{ metalType: MetalTypeEnum }>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { metalType } = action.payload;

    const response = yield* call([api, api.createGoldConversionDrafts], {
        authToken,
        metalType
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateGoldConversionDraftsFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldSetIsCreateGoldConversionModalOpen(true));
        yield put(combinedActions.goldCreateGoldConversionDraftsSuccess(response.data));
    }
}
